import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription, tap } from 'rxjs';
import { DialogService } from '../../../dialog/services/dialog.service';
import { OrganisationService } from '../../../organisation/organisation/services/organisation.service';
import { ReviewRequestDTO } from '../../Model/reviewRequestDTO';
import { RequestService } from '../../services/requests.services';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PagedResults } from '../../Model/pagedresults';
import { RequestDetailDialogComponent } from '../../request-detail-dialog/request-detail-dialog.component';

@Component({
  selector: 'app-closed-request-list',
  templateUrl: './closed-request-list.component.html',
  styleUrls: ['./closed-request-list.component.css']
})
export class ClosedRequestListComponent implements OnInit, AfterViewInit, OnDestroy {
  requests!: ReviewRequestDTO[];
  dataSource: any;
  isListloading = false;
  displayedColumns: string[] = ['id', 'title', 'status', 'deadline'];
  currentOrganisation: any;  
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  organisationSubscriber!: Subscription;
  paginationSubscription?: Subscription;
  dialogBoxSubscription?: Subscription;
  isError = false;
  errorMessage!: string;
  totalRecords?: number;
  isEmptyList = false;

  constructor(private readonly dialog: MatDialog,
    private readonly requestService: RequestService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,    
    private readonly organisationService: OrganisationService,
    private readonly dialogService: DialogService) {
  }
   
  ngOnDestroy(): void {
    this.organisationSubscriber.unsubscribe();
    this.paginationSubscription?.unsubscribe();
    this.dialogBoxSubscription?.unsubscribe();
  }

  getclosedrequests() {
    this.isError = false;
    this.isListloading = true;
    this.requestService.getclosedrequests(
      this.paginator?.pageSize ?? 10,
      this.paginator?.pageIndex ?? 0     
    ).subscribe({
      next: (response: PagedResults) => {
        this.requests = response.records;
        this.totalRecords = response.totalRecords;
        this.isEmptyList = this.totalRecords == null ? true : false;
      },
      error: (err: any) => {
        this.isError = true;
        this.errorMessage = err.error;
        this.isListloading = false;
      },
      complete: () => { this.isListloading = false; }
    });
  }

  ngOnInit() {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });    
    this.getclosedrequests();
  }

  ngAfterViewInit(): void {
    this.paginationSubscription=this.paginator?.page.pipe(tap(() => this.getclosedrequests())).subscribe();
  }
  onRequestNaviagte(requestId: number) {    
    const requestDialogRef = this.dialog.open(RequestDetailDialogComponent, {
      data: { id: requestId },
      width: '100%',
      height: '100%',
      maxWidth:'100vw',
    });
    this.dialogBoxSubscription = requestDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.router.navigate(['/closedrequests'], { relativeTo: this.route });
      }
    });
  }
  onRequestNaviagteNewPage(requestId:number){
    const url = this.router.createUrlTree([`/request/detail/${requestId}`], { relativeTo: this.route }).toString();
    window.open(url, '_blank');
  }
}
